import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cancelPipelineRunQuery } from '../apis';
import queryKeys from '../constants/queryKeys';

// POST /api/pipelines/{id}/runs/{runId}/cancel — deploy-pipelines-run-cancel (Wave 5,
// AC-19/TC-DPRC-022). Mirrors useRunPipeline's mutation idiom, and invalidates EXACTLY the
// same queries a successful trigger does, so a successful cancel is reflected everywhere a
// successful run trigger already is. Takes only { id, runId } — no PAT, no credential of any
// kind (AC-16).
//
// Deliberately does NOT stand up any polling of its own: the transition to Cancelled is left
// for the page's single existing poller (PipelineRunStatusView's usePollPipelineRun) to
// observe on its next tick — Wave 1's AC-17 "one poller on this page" invariant holds.
const useCancelPipelineRun = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: cancelPipelineRunQuery,
    onSuccess: (_result, variables) => {
      // Same three invalidations as useRunPipeline's onSuccess (AC-19/TC-DPRC-022):
      // the run history for this pipeline, the list's lazily-fetched latest-status cells,
      // and the build-source panel (a cancel also releases the one-active-run guard, which
      // can change what the panel has to say about the pipeline's current state).
      queryClient.invalidateQueries({ queryKey: queryKeys.getRuns(variables?.id) });
      queryClient.invalidateQueries({ queryKey: queryKeys.getList() });
      queryClient.invalidateQueries({ queryKey: queryKeys.getBuildSource(variables?.id) });
    },
  });
};

export default useCancelPipelineRun;
